<h1 mat-dialog-title>Format Script Compliance</h1>
<div mat-dialog-content>
    <div [innerHTML]="data | prettyjson"></div>
</div>
<div style="text-align: center;float:center;margin:20px;">
    <input [cdkCopyToClipboard]="dataString" matButton style="width:270px;height:30px;margin:10px 10px;" type="button" value="Copy to Clipboard"
        [mat-dialog-close]="">
</div>